export default "__VITE_ASSET__5fca5598__"